import { initLocalization } from '@adsk/alloy-react-localization';
const getLocale = language => {
  // eslint-disable-next-line no-unsanitized/method
  return import("./locales/".concat(language, ".json"));
};
const {
  useTranslation,
  withTranslation
} = initLocalization({
  getLocale
});
export { useTranslation, withTranslation };
//# sourceMappingURL=index.js.map